import { useMemo } from "react"
import { useDataTypesHooks } from "../../../../../features/data-types"
import { Modal, ModalId, useUIActions } from "../../../../../features/ui"
import { Customer, HoardOrder } from "../../../state/types"
import { useHoardHooks } from "../../../hooks/hoardHooks"
import { useActions } from "./actions"

type Props = {
    hoard: HoardOrder
    customer?: Customer
    onClosed?: () => Promise<void>
}

// Cierre de un acopio financiero con crédito pendiente: se pregunta si el restante se acredita al cliente
export const CloseFinancialHoardModal = (props: Props) => {
    const { hoard, customer, onClosed } = props

    const { formatPrice } = useDataTypesHooks()
    const { getClosingCredit } = useHoardHooks()
    const { closeModal } = useUIActions()

    const { submitCloseHoard } = useActions()

    const { pendingCredit, creditInFavor } = useMemo(() => getClosingCredit(hoard), [hoard])
    const customerLabel = customer ? `de ${customer.name}` : 'del cliente'

    const onSubmit = () => submitCloseHoard(hoard, true, onClosed)

    const onSecondarySubmit = () => {
        closeModal(ModalId.CLOSE_FINANCIAL_HOARD)
        submitCloseHoard(hoard, false, onClosed)
    }

    return (
        <Modal
            modalId={ModalId.CLOSE_FINANCIAL_HOARD}
            title="Cerrar Acopio?"
            widthSize="m"
            submitLabel="Acreditar y Cerrar"
            onSubmit={onSubmit}
            secondaryLabel="Cerrar sin Acreditar"
            secondaryKind="secondary"
            onSecondarySubmit={onSecondarySubmit}
        >
            <p>
                El acopio quedará con estado "Entregado" y tiene un crédito pendiente de <b>{formatPrice(pendingCredit)}</b> sin
                utilizar. Desea acreditarlo al cliente?
            </p>
            <p>
                <b>Acreditar:</b> lo adeudado se reduce a lo utilizado{creditInFavor > 0 ?
                    <> y <b>{formatPrice(creditInFavor)}</b> pasan al crédito a favor {customerLabel}.</> :
                    '. No hay montos pagados de más para pasar al crédito a favor.'}
            </p>
            <p>
                <b>Cerrar sin acreditar:</b> el crédito pendiente no se reintegra y lo adeudado no cambia.
            </p>
        </Modal>
    )
}
